import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    getSentFiles: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/banking/accessProfile/').then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    uploadFile: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.post('/uploadFile', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getFileLayout: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get('/uploadFile/layout', data).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/fileUploader.js